<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form ref="emailForm" :model="emailForm" :rules="rules" label-width="100px" :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="标题" prop="title">
            <el-input v-model="emailForm.title" style="width:875px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="邮件类型" prop="type">
            <el-select v-model="emailForm.type" placeholder="邮件类型" style="width:300px" @change="handleTypeChange">
              <el-option label="全局邮件" :value="1"></el-option>
              <el-option label="固定邮件" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="触发类型" prop="triggerType">
            <el-select v-model="emailForm.triggerType" placeholder="触发类型" style="width:300px" @change="handleChange" :disabled="emailForm.type===2">
              <el-option label="按条件" :value="1"></el-option>
              <el-option label="按时间" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="触发时间:" prop="cycleType" style="margin-right:0" :rules="emailForm.triggerType===2?[ { required: true, message: '请选择时间类型', trigger: 'change' },]:[]">
            <el-select placeholder="请选择" v-model="emailForm.cycleType " style="width: 98px" :disabled="emailForm.triggerType!==2">
              <!-- <el-option label="每天执行" :value="1"></el-option> -->
              <el-option label="执行一次" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="value" :rules="emailForm.triggerType===2?[ { required: true, message: '请选择触发时间', trigger: 'change' },]:[]">
            <el-date-picker :disabled="emailForm.triggerType!==2" :picker-options="pickerOptions" style="width:195px" v-model="emailForm.value" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-select v-model="emailForm.status" placeholder="状态" style="width:300px">
              <el-option label="开启" :value="1"></el-option>
              <el-option label="关闭" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="触发条件" prop="eventType" :rules="emailForm.triggerType===1?[ { required: true, message: '请选择触发条件', trigger: 'change',type:'number' },]:[]">
            <el-select v-model="emailForm.eventType" placeholder="触发类型" style="width:300px" :disabled="emailForm.triggerType!==1" @change="handleTimeChange" filterable >
              <!-- <el-option label="用户注册后" :value="1"></el-option>
              <el-option label="首次绑定店铺时" :value="2"></el-option> -->
              <!-- <el-option label="用户出单后" :value="4"></el-option> -->
              <!-- <el-option label="标记发货后" :value="5"></el-option>
              <el-option label="定制需求创建后" :value="6"></el-option>
              <el-option label="订单付款后" :value="7"></el-option>
              <el-option label="kaka产品下架后" :value="8"></el-option>
              <el-option label="加购未下单" :value="9"></el-option>
              <el-option label="订单未付款---代发用户" :value="4"></el-option>
              <el-option label="订单未付款---批发用户" :value="10"></el-option> -->
              <!-- <el-option label="kaka产品下架后" :value="8"></el-option> -->
              <el-option v-for="item in eventList" :key="item.eventType" :value="item.eventType" :label="item.eventName"></el-option>
            </el-select>
            <el-select style="width:120px;margin-left:15px"  v-model="emailForm.sendWaitHours" @change="handleTimeChange">
              <el-option label="立即" :value="0" v-if="emailForm.eventType!==2"></el-option>
              <el-option label="24小时后" :value="24" v-if="emailForm.eventType!==4"></el-option>
              <el-option label="72小时后" :value="72" v-if="emailForm.eventType!==4"></el-option>
            </el-select>
            <el-select style="width:150px;margin-left:15px" v-model="emailForm.eventCondition" v-if="emailForm.eventType===1&&emailForm.sendWaitHours&&emailForm.sendWaitHours!==0|| emailForm.eventType===2 &&emailForm.sendWaitHours&&emailForm.sendWaitHours!==0">
              <el-option label="未绑定店铺" :value="0" v-if="emailForm.eventType===1"></el-option>
              <el-option label="未上传产品" :value="1" v-if="emailForm.eventType===2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="emailForm.type!==1">
          <el-form-item label="邮箱地址" prop="targetEmail" :rules="emailForm.type===2?[{ required: true, message: '请输入邮件地址', trigger: 'blur' }]:[]">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="输入多个邮箱请用英文逗号隔开" style="width:875px" v-model="emailForm.targetEmail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="emailForm.type!==2">
          <el-form-item label="剔除用户" prop="exceptEmail">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="输入多个邮箱请用英文逗号隔开" style="width:875px" v-model="emailForm.exceptEmail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="emailForm.eventType">
          <el-form-item label="字段标签">
            <div class="labelButtonGroup f">
              <!-- <el-button @click="labelAddClick(item)" v-for="item in dynamicLabelList" :key="item.key">{{ item.label }}</el-button> -->
              <dynamicLabelButton :data="replaceContent" @itemClick="labelAddClick" :isFirstFloor="true"></dynamicLabelButton>
              <div>
                <el-button @click="getEmailTaskeEmailReplacePreview">预览</el-button>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="插入表格">
            <el-button @click="insertTable">插入</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="emailContent">
            <rich-editor :value="emailForm.emailContent" :disabled="isDisabledEditor" style="width:100%" @input="inputRichEditorValue" ref="tinymce" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitEmail" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import RichEditor from '../../copywriting/components/RichEditor'
import dynamicLabelButton from './dynamicLabelButton.vue'
import { emailTemplate, emailTemplate2, markShipmentTemplate, afterPaymentTemplate, publishTemplate, afterProductInfoPayment } from './data'
export default {
  components: { RichEditor, dynamicLabelButton },
  props: {
    isEdit: {
      typeof: Boolean,
      default: false
    },
    eventList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isDisabledEditor: false,
      dialogVisible: false,
      loading: false,
      disabled: false,
      title: '添加',
      value: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      emailForm: {
        triggerType: undefined,
        emailContent: '',
        triggerCondition: {},
      },
      eventValue: '',
      id: undefined,
      rules: {
        title: [{ required: true, message: '请输入邮件标题', trigger: 'blur' }, { max: 250, message: '最多可输入250个字符', trigger: 'change' }],
        type: [{ required: true, message: '请输选择邮件类型', trigger: 'change' }],
        triggerType: [{ required: true, message: '请选择邮件触发类型', trigger: 'change' }],
        status: [{ required: true, message: '请选择邮件状态', trigger: 'change' }],
        emailContent: [{ required: true, message: '请输入邮件内容', trigger: 'blur' }],
      },
      replaceContent: [],
      previewVisible: false,
      // eventList: []
    }
  },
  watch: {
    isEdit(value) {
      if (value === true) {
        this.title = "编辑"
      } else {
        this.title = "添加"
      }
    }
  },
  computed: {
    dynamicLabelList() {
      if(this.emailForm.eventType) {
        const dynamicLabelMap = {
        1: [{key: 'userName', type: 'text', label: 'Kaka用户名'}],
        2: [{key: 'userName', type: 'text', label: 'Kaka用户名'}],
        3: [{key: 'userName', type: 'text', label: 'Kaka用户名'}, {key: 'storeName', type: 'text', label: '店铺名称'}],
        4: [{key: 'userName', type: 'text', label: 'Kaka用户名'}, {key: 'kkOrderId', type: 'text', label: 'kaka订单ID'}, {key: 'storeName', type: 'text', label: '店铺名称'}, {key: 'storeInfoVOList', label: '店铺信息', type: 'arr'}],
        5: [{key: 'userName', type: 'text', label: 'Kaka用户名'}, {key: 'kkOrderId', type: 'text', label: 'kaka订单ID'}, {key: 'orderStatus', type: 'text', label: 'kaka发货状态'}, {key: 'trackingNumbers', type: 'text', label: '追踪码'}],
        6: [{key: 'demandNo', type: 'text', label: '需求编号'}],
        7: [{key: 'userName', type: 'text', label: 'Kaka用户名'}, {key: 'kkOrderId', type: 'text', label: 'kaka订单ID'}, {key: 'shippingAddress', type: 'text', label: '收件地址'}, {key: 'storeName', type: 'text', label: '店铺名称'}, {key: 'image', type: 'text', label: '产品图片'}],
        8: [{key: 'userName', type: 'text', label: 'Kaka用户名'}, {key: 'productId', type: 'text'}, {key: 'skuCodes', type: 'text'}, {key: 'image', text: 'text', label: '产品图片'}]
      }
        return dynamicLabelMap[this.emailForm.eventType]
      }
      return []
    },
  },
  methods: {
    getEmailTaskDetail() {
      API.getEmailTaskDetail(this.id).then(res => {
        res.data.triggerCondition = JSON.parse(res.data.triggerCondition)
        let { id, title, type, targetEmail, triggerType, exceptEmail, status, emailContent, triggerCondition } = res.data
        this.emailForm = { id, title, type, targetEmail, exceptEmail, triggerType, status, emailContent, triggerCondition, 'eventType': triggerCondition.eventType, 'cycleType': triggerCondition.cycleType, 'value': triggerCondition.value }
        let arr = []
        if (this.emailForm.triggerCondition.secondaryCondition && this.emailForm.triggerCondition.secondaryCondition.length > 2) {
          arr = this.emailForm.triggerCondition.secondaryCondition.split('|')
        } else {
          this.emailForm.sendWaitHours = this.emailForm.triggerCondition.secondaryCondition
        }
        if (arr.length === 2) {
          this.emailForm.sendWaitHours = Number(arr[0])
          this.emailForm.eventCondition = Number(arr[1])
        } else if (arr.length === 1) {
          this.emailForm.sendWaitHours = Number(arr[0])
        }
        this.getEmailTaskeMailReplaceTemplateList()
      })
    },
    handleChange(value) {
      if (value === 1) {
        delete this.emailForm.cycleType
        delete this.emailForm.value
      } else {
        delete this.emailForm.eventType
        delete this.emailForm.sendWaitHours
      }
    },

    handleTimeChange() {
      if (this.emailForm.eventType === 1 && this.emailForm.sendWaitHours !== 0) {
        this.emailForm.eventCondition = 0
      }
      if (this.emailForm.eventType === 2 && this.emailForm.sendWaitHours !== 0) {
        this.emailForm.eventCondition = 1
      }
      if (this.emailForm.eventType === 2&& this.emailForm.sendWaitHours==0){
        delete this.emailForm.sendWaitHours
      }
      if(this.emailForm.eventType === 4){
        this.emailForm.sendWaitHours=0
      }
      this.getEmailTaskeMailReplaceTemplateList()
      this.$forceUpdate()
    },

    handleTypeChange(value) {
      if (value === 2) {
        this.emailForm.triggerType = 2
      }
    },
    open(id) {
      if (id) {
        this.id = id
        this.getEmailTaskDetail()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    submitEmail() {
      this.$refs['emailForm'].validate((valid) => {
        if (!valid) return

        if (this.emailForm.triggerType === 1 && (!this.emailForm.sendWaitHours&&this.emailForm.sendWaitHours!==0)) {
          this.$message.warning('请选择触发时间')
        }

        this.loading = true
        let emailForm = _.cloneDeep(this.emailForm)
        if (emailForm.targetEmail) {
          emailForm.targetEmail = emailForm.targetEmail.replace(/[ \n，]|,,/g, ",");
        }
        if (emailForm.exceptEmail) {
          emailForm.exceptEmail = emailForm.exceptEmail.replace(/[ \n，]|,,/g, ",");
        }
        if (this.emailForm.triggerType === 1) {
          if (this.emailForm.sendWaitHours !== undefined && this.emailForm.sendWaitHours !== null && this.emailForm.eventCondition !== undefined && this.emailForm.eventCondition !== null) {
            emailForm.triggerCondition = {
              'eventType': this.emailForm.eventType,
              secondaryCondition: `${this.emailForm.sendWaitHours}|${this.emailForm.eventCondition}`
            }
          } else if (this.emailForm.sendWaitHours !== null && this.emailForm.sendWaitHours !== undefined) {
            emailForm.triggerCondition = {
              'eventType': this.emailForm.eventType,
              secondaryCondition: this.emailForm.sendWaitHours
            }
          } else {
            emailForm.triggerCondition = {
              'eventType': this.emailForm.eventType,
            }
          }
          delete emailForm.eventType
          delete emailForm.sendWaitHours
          delete emailForm.eventCondition
        }
        if (this.emailForm.triggerType === 2) {
          emailForm.triggerCondition = {
            'cycleType': this.emailForm.cycleType,
            'value': this.emailForm.value
          }
          delete emailForm.value
          delete emailForm.cycleType
        }
        emailForm.triggerCondition = JSON.stringify(emailForm.triggerCondition)
        API.addEmailTask(emailForm).then((res) => {
          if (res.code === 10000) {
            this.$message.success('新增邮件成功')
            this.dialogVisible = false
            this.resetForm()
            this.$emit('submitEmail')
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.loading = false
        })
      });
    },

    resetForm() {
      this.emailForm = {
        triggerType: undefined,
        emailContent: '',
        triggerCondition: {},
      }
      // this.emailForm.emailContent = undefined
      this.$refs.emailForm.resetFields();
    },
    inputRichEditorValue(value) {
      this.emailForm.emailContent = value
    },
    labelAddClick(item) {
      const id = this.$refs.tinymce.getEditor().elementId
      const ed = this.$refs.tinymce.getEditor().editor.editorManager.get(id)
      const target = item
      const range = ed.selection.getRng()
      if(target.child) {
        const content = this.$refs.tinymce.getEditor().editor.selection.getContent({format : 'html'})
        let isHaveList;
        let startIndex = this.emailForm.emailContent.indexOf(content)
        // 判断是否重复标识
        if(content.indexOf(`kakaclo-for-${target.code}`) !== -1) {
          isHaveList = true
        }
        // 获取选中内容有不返回完整标签的情况，截取前20位字符判断
        if(startIndex !== -1) {
          let forwardContent = this.emailForm.emailContent.slice(startIndex-20>0? startIndex - 20: 0, 20)
          if(forwardContent.indexOf(`kakaclo-for-${target.code}`) !== -1) isHaveList = true
        }
        // 相同标识内不能包含相同标识
        if(content && !isHaveList) {
          let innerHTMLText = `<section class='kakaclo-for-${target.code}' style="border: 2px solid ${item.color}">${content}</section>`
          let newContent = this.emailForm.emailContent.replace(content, innerHTMLText)
          this.emailForm.emailContent = newContent
        }
      } else {
        let divNode = ed.getDoc().createElement('i');
        divNode.innerHTML = ('${' + item.code + '}');
        range.insertNode(divNode);
      }
    },
    labelItemClick(item) {
      console.log(item)
    },
    getEmailTaskeMailReplaceTemplateList() {
        API.getEmailTaskeMailReplaceTemplateList({eventType: this.emailForm.eventType}).then(res=>{
          if(!res.data.length){
            this.replaceContent = []
            return
          }
          const replaceContent = JSON.parse(res.data[0].replaceContent)
          function setColor(arr) {
            arr.forEach(e=>{
              if(e.code === 'storeInfoVOList') e.color = '#e6a23c'
              if(e.code === 'listingInfoVOList') e.color = '#67c23a'
              if(e.code === 'skuInfoVOList') e.color = '#409eff'
              if(e.child) setColor(e.child)
            })
          }
          setColor(replaceContent)
          this.replaceContent = replaceContent
        })
    },
    getEmailTaskeEmailReplacePreview() {
        const params = {
            eventType: this.emailForm.eventType,
            replaceContent: this.emailForm.emailContent
        }
        API.getEmailTaskeEmailReplacePreview(params).then(res=>{
          this.previewVisible = true
          this.$emit('preview', res.data)
        })
    },
    insertTable() {
      const id = this.$refs.tinymce.getEditor().elementId
      const ed = this.$refs.tinymce.getEditor().editor.editorManager.get(id)
      const range = ed.selection.getRng()
      let divNode = ed.getDoc().createElement('i');
      // 9加购未下单、10订单未付款-代发用户、11订单未付款-批发用户、5标记发货后、7订单付款后
      if(![9, 10, 11, 5, 7, 8, 12, 15].includes(+this.emailForm.eventType)) {
        let ttt = "<table style=\"border-collapse: collapse; width: 85.1315%; height: 63px;\" border=\"1\">\n" +
                "<tbody class=\"trFather\">\n" +
                "<tr style=\"height: 21px;\">\n" +
                "<td style=\"width: 220px; height: 21px; text-align: center;\"><span style=\"color: #000000;\">Photo</span></td>\n" +
                "<td style=\"width: 29.1627%; height: 21px; text-align: center;\"><span style=\"color: #000000;\">Product Title</span></td>\n" +
                "<td style=\"width: 32.1537%; height: 21px; text-align: center;\"><span style=\"color: #000000;\">Sku</span></td>\n" +
                "</tr>\n" +
                "<tr class=\"kakaclo-for-spuRemovedVOList\" style=\"height: 21px;\">\n" +
                "<td style=\"width: 220px; height: 21px;text-align: center;\"><span style=\"color: #000000;\">${photo}</span></td>\n" +
                "<td style=\"width: 29.1627%; height: 21px;text-align: center;\"><span style=\"color: #000000;\">${productTitle}</span></td>\n" +
                "<td style=\"width: 32.1537%; height: 21px;text-align: center;\"><span style=\"color: #000000;\">${sku}</span></td>\n" +
                "</tr>\n" +
                "</tbody>\n" +
                "</table>"
        divNode.innerHTML = (ttt);
        if(this.emailForm.emailContent.includes('kakaclo-for-spuRemovedVOList')) return
        range.insertNode(divNode);
      } else {
        if([9].includes(+this.emailForm.eventType))divNode.innerHTML = (emailTemplate2)
        if([11, 10].includes(+this.emailForm.eventType))divNode.innerHTML = (emailTemplate)
        if([5].includes(+this.emailForm.eventType)) divNode.innerHTML = (markShipmentTemplate)
        if([7].includes(+this.emailForm.eventType)) divNode.innerHTML = (afterPaymentTemplate)
        if([8, 12].includes(+this.emailForm.eventType)) divNode.innerHTML = (publishTemplate)
        if([15].includes(+this.emailForm.eventType)) divNode.innerHTML = (afterProductInfoPayment)
        if(this.emailForm.emailContent.includes('kakaclo-for-template')) return
        range.insertNode(divNode);
      }
      this.$refs.tinymce.getFouse()
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
